export default __webpack_public_path__ + "static/media/history-4.5c488399.png";